import { useContext } from "react";
import { DisclosuresContext } from "./DisclosuresContext";

const useDisclosures = () => {
  const { disclosures, setDisclosures, disclosuresInCorrectOrder } = useContext(DisclosuresContext);

  return { disclosures, setDisclosures, disclosuresInCorrectOrder };
};

export { useDisclosures };
